import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-detail-asesor-dashboard',
  templateUrl: './detail-asesor-dashboard.component.html',
  styleUrls: ['./detail-asesor-dashboard.component.scss']
})
export class DetailAsesorDashboardComponent implements OnInit {
  @Input() dashboard:any;
  @Input() yearCurrent: number = 0;
  constructor() { }

  ngOnInit() {
  }

}
